import React from 'react';
import './App.css';
import Section from '../common/Section';

export default function App() {
  return (
    <Section title="[ APPS ]" link="/apps" contentClassName="app-content">
    </Section>
  );
}

